'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('./index-de1ce3ed.js');
require('react');
require('@uploadcare/client-suspense');
require('react-fast-compare');



exports.Panel = index.Panel;
exports.Widget = index.Widget;
